import type { DropdownOption, DropdownValue } from "@inno-ui/dropdown";

import { Dropdown, DropdownTriggerComponents } from "@inno-ui/dropdown";
import { useTranslation } from "react-i18next";

import { useFieldContext } from "../../hooks/use-form";

type SelectInputFieldProps = {
  label: string;
  placeholder: string;
  options: DropdownOption[];
  width?: string;
};

export function SelectInputField({ label, placeholder, options, width }: SelectInputFieldProps) {
  const { t } = useTranslation();
  const field = useFieldContext<DropdownOption>();

  return (
    <Dropdown
      placeholder={placeholder}
      label={label}
      items={options}
      width={width}
      value={field.state.value as DropdownValue}
      onChange={value => field.handleChange(value as DropdownOption)}
      trigger={{
        option: DropdownTriggerComponents.Input,
        props: {
          hasError: !!field.state.meta.errors[0]?.message,
          errorText: t(field.state.meta.errors[0]?.message),
        },
      }}
    />
  );
}
